import { render, staticRenderFns } from "./object-helper-settings.vue?vue&type=template&id=96bc9bc4&scoped=true"
import script from "./object-helper-settings.vue?vue&type=script&lang=js"
export * from "./object-helper-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bc9bc4",
  null
  
)

export default component.exports